// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Odna","header":"styles_header__1VWF8","table":"styles_table__3xuMr"};